import { enumStaticTextType } from "../constants";
import { QStaticText } from "../CoreApp/QStaticText";

export function AddWrapTextCentered(
  panel,
  xPos,
  yPos,
  availableWidth,
  label,
  bold,
  textColor,
  fontName,
  fontSize
) {
  var st = new QStaticText();
  st.InitStaticText();

  if (fontName != null) st.SetFontName(fontName);

  if (fontSize != null) st.SetFontSize(fontSize);

  st.SetLabel(label);
  st.SetBold(bold);
  st.SetAlignment("center");
  st.PositionElement(xPos, yPos);
  st.SetAvailableWidth(availableWidth);
  st.SetSizingMode(enumStaticTextType.multiline);

  st.AutoSize();

  if (textColor != null) st.SetTextColor(textColor);

  panel.PushElement(st);

  return st;
}
